import { Skeleton } from '~/components/ui/skeleton/Skeleton';

/** A stack of row placeholders for a list or panel that is loading; owns the loading announcement (DESIGN.md §11.1). */
export function SkeletonRows({ rows = 3, label = 'Loading…' }: { rows?: number; label?: string }) {
  return (
    <div role="status" aria-busy="true" className="space-y-2">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} variant="row" />
      ))}
    </div>
  );
}
